import { installOneTrust } from '../../scripts/oneTrust';
import { isLottolandNativeAppUserAgent } from '../isLottolandNativeAppUserAgent/isLottolandNativeAppUserAgent';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    dla?: {
      oneTrust?: {
        setOneTrustCookieGroups: (statisticCookies: boolean, functionalCookies: boolean, targetingCookies: boolean) => void;
      };
    };
  }
}

function installNativeScripts(userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (!isLottolandNativeAppUserAgent(userAgent)) {
    return;
  }

  installOneTrust();
}

export { installNativeScripts };
